import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MainTitle } from 'projects/common/components/main-title/main-title.component';
import { Messages, MessagesService } from 'projects/common/services/messages.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';

@Component({
  selector: 'title-pill',
  template: `
    <div class="title-pill -eva-3-valign -eva-3-mr-lg">
      <div class="title">
        <ng-container *ngIf="data.pre_title?.text">
          <tag-text class="title-text" [data]="data.pre_title"></tag-text>
        </ng-container>
        <tag-text class="title-text" [data]="data.title"></tag-text>
      </div>
      <div>
        <img class="title-pill-image" [src]="logo" alt="{{data.title?.text}}" loading="lazy">
      </div>
    </div>
  `,
  styleUrls: ['./title-pill.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class TitlePillComponent {
  @Input() data: MainTitle;
  @Input() logo: string;

  messages: Messages;

  constructor(messagesService: MessagesService, landingModelService: LandingModelService) {
    const landing = landingModelService.getLandingModel();
    this.messages = messagesService.getMessages(landing.language, landing.country);
  }

}
